// extracted by mini-css-extract-plugin
export default {"noResizeTextArea":"style_noResizeTextArea__SbQ-e"};